import { prize, prizeType } from "../../../../utils/timer";
import { MoneyInChip } from "../../../tournament/hook/useEditTournament";
import { Timer3PrizeBoxWrapper } from "../../timer1/styles/vertical";

const Timer3PrizeBox = ({
  data,
  item,
  index,
  subPrizeFont,
}: {
  data: any;
  item: MoneyInChip;
  index: number;
  subPrizeFont: number;
}) => {
  return (
    <Timer3PrizeBoxWrapper subPrizeFont={subPrizeFont}>
      <span>{prize(data, item, index)}</span>
      {prizeType(item)}
      {item.subPrize && <div className="sub">{item.subPrize}</div>}
    </Timer3PrizeBoxWrapper>
  );
};

export default Timer3PrizeBox;
